import __ from "@feniks-pwa/web-app/web/Layout/Translations";
import classify from "@feniks-pwa/web-app/web/classify";
import { bool, func, node, shape, string } from "prop-types";

import defaultClasses from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/ChangeDataFormWrapper/changeDataFormWrapper.scss";

import Button from "web/Components/Common/Button/button";
import TransparentButton from "web/Components/Common/TransparentButton/transparentButton";

const CheckoutSubscriptionChangeDataFormWrapper = ({
  classes,
  children,
  onCancelClick,
  onSendClick,
  areButtonsDisabled,
  acceptBtnText,
}) => {
  return (
    <div>
      {children}
      <div className={classes.buttonsContainer}>
        <TransparentButton
          type="button"
          onClick={onCancelClick}
          disabled={areButtonsDisabled}
        >
          {__("Anuluj")}
        </TransparentButton>
        <Button
          type="button"
          variant="primary"
          onClick={onSendClick}
          disabled={areButtonsDisabled}
        >
          {__(acceptBtnText)}
        </Button>
      </div>
    </div>
  );
};

CheckoutSubscriptionChangeDataFormWrapper.propTypes = {
  classes: shape({}).isRequired,
  children: node.isRequired,
  onCancelClick: func.isRequired,
  onSendClick: func.isRequired,
  areButtonsDisabled: bool,
  acceptBtnText: string,
};

CheckoutSubscriptionChangeDataFormWrapper.defaultProps = {
  areButtonsDisabled: false,
  acceptBtnText: "Zapisz zmiany",
};

export default classify(defaultClasses)(
  CheckoutSubscriptionChangeDataFormWrapper
);
